import axios, { Method } from 'axios';
import { Executable, IPrepareRequestOptions } from '../executable';
import {
  IWalletTemplateCreateInput,
  IWalletTemplatePassData,
  IWalletTemplateAndroidPassData,
  IWalletTemplateFieldMapping,
  BambuPassStyles,
} from '../interfaces/wallet-template';
import { UploadTemporaryFile } from './upload-temporary-file';

// had to make some hack to make the module be imported
let fileTypeModule: any;

export interface IWalletTemplateResponse extends Required<IWalletTemplateCreateInput> {}

export interface IGetWalletTemplateInput {
  brandId: number;
  programId: number;
}

export class GetWalletTemplate
  extends Executable<IWalletTemplateResponse>
  implements Partial<IGetWalletTemplateInput>
{
  public brandId?: number;

  public programId?: number;

  public getMethod(): Method {
    return 'get';
  }

  public getResponse(apiResponse: any): IWalletTemplateResponse {
    const response = apiResponse;
    if (response?.sharingUrl === null) {
      response.sharingUrl = '';
    }
    return response;
  }

  public getURLPath(tenantId?: string): string {
    return `${this.brandId}/programs/${this.programId}/templates`;
  }

  constructor(input?: Partial<IGetWalletTemplateInput> & { tenantId: number; name: string }) {
    super();
    if (input) {
      Object.assign(this, input);
    }
  }

  /**
   * getBody is used by the BambuClient to properly construct the request object body.
   * @returns Returns the expected body of the request utilizing the defined request attributes.
   */
  getBody() {
    return undefined;
  }

  /**
   * getRootPath is used by the BambuClient to properly construct the request call.
   * @returns The root path of the request
   */
  getRootPath(): string | undefined {
    return 'brands';
  }
}

export { BambuPassStyles };
